module.exports = __webpack_public_path__ + "static/whatis-finance-open-graph-f4e5d0c3788a89f96d1615881ace5a97.png";